import { SuiteType } from 'projects/miq/stacking-plan/src/lib/stacking-plan-container/floor-container/floor/item/item.model';
/**
 * Common constants used throughout the application
 */
/**
 * Array of month names in English (abbreviated)
 */
export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/**
 * Locales that use a non-US number format (comma as decimal separator).
 * Add new locale codes here when additional countries adopt this number format.
 */
// CE_LOCALES moved to @miq/shared-models (leaf; see L2-P3). Re-exported for compat.
// L2-S4: its two disjoint halves followed, for ExcelSharedService / the measurement formatters.
export { CE_LOCALES, CE_COMMA_SPACE_DECIMAL_LOCALES, CE_COMMA_DOT_DECIMAL_LOCALES } from '@miq/shared-models';
// L2-R1: AutomationCountries / PropertyDataCascadeCountries moved to @miq/shared-models
// (constants/country-groups.const.ts) so UserLocaleService could move into @miq/platform
// without dragging this file's @miq/stacking-plan import. Re-exported for compat.
export { AutomationCountries, PropertyDataCascadeCountries } from '@miq/shared-models';


/**
 * Storage key for locale ID in localStorage
 */
export const LOCALE_ID_STORAGE_KEY = 'localeId';
/**
 * Gets the current locale ID from localStorage and maps it to an Angular locale code.
 *
 * @returns The Angular locale code, or a default if not found or invalid
 */
// L2-R7: CONTACT_FILTER / MOBILE_PHONE / BUSINESS_PHONE moved to @miq/shared-models
// (constants/contact-filter.constants.ts) — they were the only three symbols the reports remote
// needed from this file, and the file itself cannot move because of its @miq/stacking-plan
// `SuiteType` import (stacking-plan is built after shared-models). Re-exported for compat.
export { CONTACT_FILTER, MOBILE_PHONE, BUSINESS_PHONE } from '@miq/shared-models';
export const ALREADY_EXISTS = 'Already Exists';

/**
 * sessionStorage marker set for the lifetime of an Office-dialog window opened
 * by the Outlook add-in (see seedOutlookSessionFromUrl in app.config.ts).
 * Mirrored as a literal in the index.html pre-boot theme script, which cannot import.
 */
export const OUTLOOK_DIALOG_SESSION_KEY = 'outlook_dialog';
// CE-7464 Certain new fields not available in the bulk Edit template for Retail
export const CUSTOMIZED_SECTIONS_TITLES_BULK_EDIT = ['Property Availability/Vacancy'];
export const DUPLICATE_TRANSLATION_OBJ = {
  [SuiteType.Availability]: 'duplicateSpace.noteAvailabilityOffMarket',
  [SuiteType.Lease]: 'duplicateSpace.noteLeaseExpired',
  [SuiteType.Tenant]: 'duplicateSpace.noteTenantExpired',
};
// L2-S1/T7: keyActions / mentionsRegex moved to @miq/shared-models
// (constants/comment-mentions.const.ts) so CommentsComponent could move to @miq/platform-ui.
// Re-exported for compat.
export { keyActions, mentionsRegex } from '@miq/shared-models';
export const HOTEL_STARS_EXTERNAL_RATING_TYPE_VALUE = 'Hotel Star';
// CE-8454: Recipients for ownership change email notification (usage type)
export const OWNERSHIP_CHANGE_NOTIFICATION_RECIPIENTS = ['shivakrishna.k@cbre.com', 'jesus.parla@cbre.com','sanathkumar.bonda@cbre.com'];
// CE-10090 / CE-11493: moved to @miq/shared-models (constants/notification-user-groups.const.ts) so
// the admin remote can use it without a host import.
export { DE_PROPERTY_OWNER_NOTIFICATION_USER_GROUP } from '@miq/shared-models';
// CE-12040  [UX Enhancement] Total Available Space Validation
export const TOTAL_AVAILABLE_EXCEEDS_PROPERTY_CODE = 'totalAvailableExceedsProperty';